"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  ExtractCriteriaRequest,
  MindstringPrototype,
} from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { extractCriteria } from "../api/extractCriteria";
import { criteriaKeys } from "../queries/keys";

interface UseExtractCriteriaMutationProps {
  targetId?: string | null;
  prototypeCategory?: MindstringPrototype | null;
}

export default function useExtractCriteriaMutation({
  targetId,
  prototypeCategory,
}: UseExtractCriteriaMutationProps) {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();
  const queryKey = targetId
    ? criteriaKeys.list({
        targetId,
        prototypeCategory: prototypeCategory ?? undefined,
      })
    : criteriaKeys.all;

  return useMutation({
    mutationFn: (request: ExtractCriteriaRequest) =>
      extractCriteria(accessToken, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey });
    },
  });
}
